module.exports = __webpack_public_path__ + "static/media/Calendar.4534dc6b.svg";